import { useEffect, useState } from 'react';
import { TableColumn } from 'react-data-table-component';
import { useHistory } from 'react-router-dom';
import { useMemo } from 'react';
import ListComponent from '../../../components/ListComponent';
import moment from 'moment';
import { LowLevelProductFilter } from './LowLevelProductFilter';
import { useQueryParamsReplace } from '../../../utils/useQueryParamsReplace';
import { ReportLowLevelProductModel } from '../models/ReportLowLevelProductModel';
import { reportsServices } from '../services/ReportsServices';
import {
  initialFilterLowLevelProduct,
  queryParamsLowLevelProductConfig,
} from '../utils/utils';
import { RootState } from '../../../redux';
import { UserGroupRelationModel } from '../../auth/models/UserGroupRelationModel';
import { shallowEqual, useSelector } from 'react-redux';

export function LowLevelProduct() {
  // Pagination, Filter and Query Params
  const [totalCount, setTotalCount] = useState(0);
  const [entities, setEntities] = useState<ReportLowLevelProductModel[]>([]);

  const [queryParams, setQueryParams] = useQueryParamsReplace(
    queryParamsLowLevelProductConfig
  );

  const history = useHistory();

  // useMemo will only be created once
  const columns: TableColumn<ReportLowLevelProductModel>[] = useMemo(
    () => [
      {
        name: 'Client',
        selector: (row) => row.client,
        sortable: true,
        sortField: 'client',
        wrap: true,
        width: '200px',
      },
      {
        name: 'Product Code',
        selector: (row) => row.productCode,
        sortable: true,
        sortField: 'productCode',
      },
      {
        name: 'Current Level',
        selector: (row) => row.currentLevel,
        sortable: true,
        sortField: 'currentLevel',
      },
      {
        name: 'Low Level',
        selector: (row) => row.lowLevel,
        sortable: true,
        sortField: 'lowLevel',
      },
      {
        name: 'Most Recent Usage',
        selector: (row) =>
          row.mostRecentUsage
            ? moment(row.mostRecentUsage).format('MM-DD-YYYY')
            : '-',
        sortable: false,
        sortField: 'startTime',
      },
      {
        name: 'Quantity Ordered',
        selector: (row) => row.quantityOrderedLastDays,
        sortable: false,
        sortField: 'quantityOrderedLastDays',
        wrap: true,
      },
      {
        name: 'Avg. Weekly',
        selector: (row) => row.avgWeeklyLastDays,
        sortable: false,
        sortField: 'avgWeeklyLastDays',
      },
      {
        name: 'Approx Weeks',
        selector: (row) => row.approxWeeksWithAvailability,
        sortable: false,
        sortField: 'approxWeeksWithAvailability',
      },
      {
        name: 'Approx Date',
        selector: (row) =>
          row.approxLastDateWithAvailability
            ? moment(row.approxLastDateWithAvailability).format('MM-DD-YYYY')
            : '-',
        sortable: false,
        sortField: 'approxLastDateWithAvailability',
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const userGroupRelations = useSelector<RootState, UserGroupRelationModel>(
    ({ auth }: any) => auth.userGroupRelation,
    shallowEqual
  );
  //Initialization methods
  useEffect(() => {
    if (history.location.search === '') {
      const newQueryParams = {
        ...initialFilterLowLevelProduct,
        accountId: userGroupRelations.accountId
          ? userGroupRelations.accountId
          : undefined,
        clientId: userGroupRelations.clientId
          ? userGroupRelations.clientId
          : undefined,
        franchiseId: userGroupRelations.franchiseId
          ? userGroupRelations.franchiseId
          : undefined,
        locationId: userGroupRelations.locationId
          ? userGroupRelations.locationId
          : undefined,
      };
      setQueryParams(newQueryParams);
    }

    if (queryParams.pageNumber) find(queryParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams]);

  const find = function (queryParams: any) {
    reportsServices.lowLevelProduct(queryParams).then((response) => {
      setEntities(response.data.items);
      setTotalCount(response.data.totalCount);
    });
  };
  const download = function () {
    reportsServices.lowLevelProductDownload(queryParams).then((response) => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([response.data]));
      link.setAttribute('download', 'low-level-product.csv');
      link.click();
    });
  };

  const customTableStyles = {
    rows: {
      style: {},
    },
    headCells: {
      style: {
        fontSize: '14px',
        color: '#a1a5b7',
      },
    },
    cells: {
      style: {},
    },
    pagination: {
      style: {
        justifyContent: 'flex-start',
      },
    },
  };

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header py-6'>
          <div className='card-title'>
            <label className='mr-auto'>Last {queryParams.lastXDays} days</label>
          </div>
          <div className='card-toolbar'>
            <LowLevelProductFilter
              queryParams={queryParams}
              setQueryParams={setQueryParams}
            />
            <button
              type='button'
              className='btn btn-primary align-self-center'
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
              onClick={(e) => {
                e.preventDefault();
                download();
              }}
            >
              <i className='fas fa-download fs-2'></i>
              Download
            </button>
          </div>
        </div>

        <div className='card-body px-9 py-3'>
          <ListComponent
            table={{
              columns,
              data: entities,
              paginationTotalRows: totalCount,
            }}
            queryParams={queryParams}
            setQueryParams={setQueryParams}
            customStyles={customTableStyles}
          />
        </div>
      </div>
    </>
  );
}
